import { ReadStatus } from 'app/constants/import/readStatus'

export const getReadStatus = (status): ReadStatus => {
  let readStatus = ReadStatus.Unknown

  switch (status) {
    case 0:
      readStatus = ReadStatus.Complete
      break
    case 1:
      readStatus = ReadStatus.Warning
      break
    case 2:
      readStatus = ReadStatus.Waiting
      break
    case 4:
      readStatus = ReadStatus.Terminated
      break
    case 5:
      readStatus = ReadStatus.Error
      break
  }

  return readStatus
}
